import React from 'react';
import { Hero } from '../components/sections/Hero';
import { TrustBar } from '../components/sections/TrustBar';
import { AboutDestaMeet } from '../components/sections/AboutDestaMeet';
import { WhatWeDoForYou } from '../components/sections/WhatWeDoForYou';
import { WhyDestaMeet } from '../components/sections/WhyDestaMeet';
import { RoiStats } from '../components/sections/RoiStats';
import { ProcessTimeline } from '../components/sections/ProcessTimeline';
import { SocialProof } from '../components/sections/SocialProof';
import { CtaSection } from '../components/sections/CtaSection';
export function Home() {
  return <>
      <Hero data-id="element-2360" />
      <TrustBar data-id="element-2361" />
      <AboutDestaMeet data-id="element-2362" />
      <WhatWeDoForYou data-id="element-2363" />
      <WhyDestaMeet data-id="element-2364" />
      <RoiStats data-id="element-2365" />
      <ProcessTimeline data-id="element-2366" />
      <SocialProof data-id="element-2367" />
      <CtaSection data-id="element-2368" />
    </>;
}